import * as _ from 'gleam:prelude'
import * as ctx from 'gleam:redraw/unsafe/context'
import * as React from 'react'

const contexts = {}

export function createContext(name, defaultValue) {
  if (contexts[name]) return _.Result$Error(ctx.Error$ExistingContext(name))
  contexts[name] = React.createContext(defaultValue)
  return _.Result$Ok(contexts[name])
}

export function getContext(name) {
  const context = contexts[name]
  if (context) return _.Result$Ok(context)
  const error = ctx.Error$UnknownContext(name)
  return _.Result$Error(error)
}
